import type { Routes } from '@angular/router';
import { authGuard } from './core/auth/guards/auth.guard';
import { EVENT_ROUTES, HOME_ROUTES, PUBLIC_ROUTES, RoutePaths } from './core/config/routes.config';

export const routes: Routes = [
  ...PUBLIC_ROUTES,
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: RoutePaths.HOME,
        pathMatch: 'full',
      },
      ...HOME_ROUTES,
      ...EVENT_ROUTES,
    ],
  },

  {
    path: '**',
    redirectTo: RoutePaths.HOME,
  },
];
